import { appstr } from "../utils/appstr";
import { Div2Floor } from "../utils/Div2Floor";
import { doDrawImage } from "../utils/doDrawImage";
import { enumIconIndex, enumIconIndex16, enumImageIndex, kOCNTextColor } from "../constants";
import { MapFieldDefToImage } from "../utils/MapFieldDefToImage";
import { QPanel } from "./QPanel";
import { QPanelDragger } from "./QPanelDragger";
import { SetCtxFont } from "../utils/SetCtxFont";

export class QFieldElement extends QPanelDragger {
  constructor() {
    super();
    this.fFieldDef = null;
    this.fIsFreeText = null;
    this.fSourcePanel = null;
    this.fGrabberX = 2;
    this.fGrabberWidth = 16;
    this.fLimitToGrabber = true;
    this.fIcon = null;
  }

  GetGrabberHeight(iconGrabber) {
    var theHeight = 8;
    if (iconGrabber) theHeight = 16;
    if (this.fHeight < 8) theHeight = this.fHeight;
    return theHeight;
  }

  InitFieldElement(fieldDef, sourcePanel, parentPanel, launchDrag, isFreeText, imageMgr) {
    this.InitPanelDragger(parentPanel);
    this.fFieldDef = fieldDef;
    this.fIsFreeText = isFreeText;
    this.fSourcePanel = sourcePanel;

    this.SetFillColor("#FFFFFF");
    this.SetIsSelectable(false);
    this.SetIsControl(true);

    /*
  var imageRef;
  if (isFreeText) imageRef = enumIconIndex16.texttype;
  else imageRef = MapFieldDefToImage(fieldDef);
  if (imageRef != null) this.DoSetImage(imageRef, imageMgr);
   */
  }

  DoSetImage(imageRef, imageMgr) {
    var yOffset = Math.floor(imageRef / 12);
    var xOffset = imageRef % 12;

    var enabledImageIdx = enumImageIndex.enable16;
    var xSpacing = 16;
    var ySpacing = 16;

    var xSize = 16;
    var ySize = 16;

    var enabledImage = imageMgr.GetSubImage(
      enabledImageIdx,
      xOffset,
      yOffset,
      xSize,
      ySize,
      xSpacing,
      ySpacing
    );
    this.fIcon = enabledImage;
  }

  AlternateStartInteractWithElement(canvasX, canvasY, panelX, panelY, shiftDown) {
    var grabberLeft;
    var grabberRight;
    var grabberTop;
    var grabberBottom;
    var grabberHeight = this.GetGrabberHeight(this.fIcon);
    var buffer = 3;
    if (this.fLimitToGrabber) {
      // Add a little slop so the user doesn't have to be right on the money
      grabberLeft = this.fGrabberX - buffer;
      grabberRight = grabberLeft + this.fGrabberWidth + buffer;

      grabberTop = (this.fHeight - grabberHeight) / 2 - buffer;
      if (grabberTop < 0) grabberTop = 0;

      grabberBottom = grabberTop + grabberHeight + buffer;
      if (grabberTop > this.fHeight) grabberTop = this.fHeight;
    } else {
      grabberLeft = 0;
      grabberRight = this.fWidth;
      grabberTop = 0;
      grabberBottom = this.fHeight;
    }

    var localX = panelX - this.fHorzOffset;
    var localY = panelY - this.fVertOffset;

    if (localX >= grabberLeft && localX <= grabberRight) {
      if (localY >= grabberTop && localY <= grabberBottom) {
        this.fSourcePanel.StartFieldDrag(this, canvasX, canvasY);
        return true;
      }
    }
    return false;
  }

  CalculateWidth(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    SetCtxFont(ctx, "14px Arial");
    var theContent = this.GetRenderContent();
    var txtDim = ctx.measureText(theContent);
    return Math.ceil(txtDim.width) + this.fGrabberWidth + this.fGrabberX + 6;
  }

  SetGrabBehavior(grabberOnly) {
    this.fLimitToGrabber = grabberOnly;
  }

  RenderGrabber(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var grabberHeight = this.GetGrabberHeight(this.fIcon);
    var sx = this.fHorzOffset + this.fGrabberX;
    var sy = this.fVertOffset + (this.fHeight - grabberHeight) / 2;
    if (this.fIcon) {
      doDrawImage(ctx, this.fIcon, 0, 0, 16, 16, sx, sy, 16, 16);
    }
  }

  DoDrawPad(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    ctx.fillStyle = "#edd5b7";
    ctx.fillRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);
    ctx.restore();
  }

  GetRenderContent() {
    var theContent;
    if (this.IsFreeText()) {
      theContent = appstr("freetext");
    } else {
      theContent = this.fFieldDef.GetFieldDisplayName();
    }
    return theContent;
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.fillStyle = "#edd5b7";
    ctx.fillRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);
    ctx.save();
    SetCtxFont(ctx, "12px Arial");
    ctx.fillStyle = kOCNTextColor;
    var theContent = this.GetRenderContent();
    var txtHOffset = this.fGrabberX + 4;
    var txtVOffset = Div2Floor(this.fHeight) + 1; // - txtHeight)-1;
    var sx = this.fHorzOffset;
    var sy = this.fVertOffset;
    var ex = sx + this.fWidth;
    var ey = sy + this.fHeight;
    ctx.beginPath();
    ctx.moveTo(sx, sy);
    ctx.lineTo(ex, sy);
    ctx.lineTo(ex, ey);
    ctx.lineTo(sx, ey);
    ctx.lineTo(sx, sy);
    ctx.closePath();
    ctx.clip();
    ctx.textBaseline = "middle";
    ctx.textAlign = "left";
    var cx = sx + txtHOffset;
    ctx.fillText(theContent, cx, this.fVertOffset + txtVOffset);
    ctx.restore();
    this.RenderGrabber(drawBuffer);
  }

  GetFieldDef() {
    return this.fFieldDef;
  }

  IsFreeText() {
    return this.fIsFreeText;
  }

  RenderSelectionHighlight(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    ctx.fillStyle = "#000000";
    var boxLeft = this.fHorzOffset;
    var boxTop = this.fVertOffset;
    var boxWidth = this.fWidth;
    var boxHeight = this.fHeight;
    ctx.globalAlpha = 0.5;
    ctx.fillRect(boxLeft, boxTop, boxWidth, boxHeight);
    ctx.restore();
  }
}
